import { createFileRoute } from '@tanstack/react-router'

import { BookCourse } from '@/components/student-dashboard/book-course'

export const Route = createFileRoute('/_student/_layout/book-courses')({
  component: BookCoursesPage,
})

function BookCoursesPage() {
  return (
    <BookCourse
      setCurrentPage={(page) => {
        if (page === 'LESSONS') {
          window.history.back()
        }
      }}
    />
  )
}
